import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { useTealiumEventProperties, useTrackPageView } from "@grandvisionhq/svc-tealium/events";
import ConfirmationReturnItem from "../../../../components/ConfirmationReturnItem/components/ConfirmationReturnItem/ConfirmationReturnItem.js";
import Layout from "../../../../components/Layout/components/Layout/Layout.js";
import { pushReturnsEvent } from "../../../../data-layer/data-layer/returns.js";
/* empty css                      */
const ConfirmationPage = ({ lineItems, returnLabelUrl }) => {
  const { getLabel } = useIntl();
  const [clickedConfirmation, setClickedConfirmation] = React.useState(false);
  const labels = {
    title: getLabel("returns.page.confirmation.title"),
    alerts: {
      title: getLabel("returns.page.confirmation.alert.title"),
      dropOffPeriod: getLabel("returns.page.confirmation.alert.dropOffPeriod"),
      clickedConfirmation: getLabel("returns.page.confirmation.alert.clickedConfirmation")
    },
    button: getLabel("returns.page.confirmation.button"),
    returnItemsTitle: getLabel("returns.page.confirmation.returnItemsTitle")
  };
  const onHandleClick = () => {
    pushReturnsEvent({ interactionType: "create_return_label" });
    setClickedConfirmation(true);
  };
  const { commonEventProperties, getCommonUserProperties } = useTealiumEventProperties();
  const accountReturnsConfirmationPageView = React.useCallback(async () => {
    const commonUserProperties = await getCommonUserProperties();
    if (!commonUserProperties) return;
    return {
      id: "VirtualPage-View",
      Page_Type: "Static",
      Page_Section1: "Account",
      ...commonUserProperties,
      ...commonEventProperties
    };
  }, [commonEventProperties, getCommonUserProperties]);
  useTrackPageView(accountReturnsConfirmationPageView);
  return /* @__PURE__ */ React.createElement(Layout, null, /* @__PURE__ */ React.createElement(Heading, { component: "h1", variant: "small" }, labels.title), returnLabelUrl ? /* @__PURE__ */ React.createElement(Alert, { variant: "info", className: "alert-m-default", title: labels.alerts.title }, clickedConfirmation && labels.alerts.clickedConfirmation, labels.alerts.dropOffPeriod) : null, lineItems && lineItems.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Heading, { component: "h2", variant: "small" }, labels.returnItemsTitle), lineItems.map((lineItem, index) => /* @__PURE__ */ React.createElement(ConfirmationReturnItem, { key: `item-${index}`, item: lineItem.lineItem }))), /* @__PURE__ */ React.createElement(
    Button,
    {
      caption: labels.button,
      className: "confirmation-page__button",
      href: returnLabelUrl ?? "",
      hrefTarget: "_blank",
      isLoading: false,
      onClick: onHandleClick
    }
  ));
};
export {
  ConfirmationPage as default
};
//# sourceMappingURL=ConfirmationPage.js.map
